import { ChangeDetectorRef, Component } from '@angular/core';
import { HeaderComponent } from '../../../../layout/header/header.component';
import { NavbarComponent } from '../../../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { Role } from '../../../../models/role';
import { RoleService } from '../../../../services/role.service';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertComponentComponent } from "../../../../components/alert/alert-component.component";
import { messageVisibility } from '../../../../models/messageVisibility.model';
import { MessageInputComponent } from "../../../../layout/message-input/message-input.component";
import { SharedService } from '../../../../services/shared.service';

@Component({
  selector: 'app-roles',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, CommonModule, ReactiveFormsModule, TranslatePipe, AlertComponentComponent, MessageInputComponent],
  templateUrl: './roles.component.html',
  styleUrl: './roles.component.css'
})
export class RolesComponent {
  links: any[] = []; // Lista de links para el sidebar

  listRole: Role[] = [];

  selectedRowId: string = '';

  updateRole: boolean = false;

  creatingRole: boolean = false;

  loadListing: boolean = true;

  errorMessage: string = '';

  messageVisibility: messageVisibility = new messageVisibility()

  constructor(private routelinks: RoutelinksService,
    private roleService: RoleService,
    private changeDetector: ChangeDetectorRef,
    public sharedService : SharedService
  ) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksAdministration; // Inicializa la propiedad en ngOnInit
    this.getAllRoleMaster();
  }

  /**
   * Funcíon encargada de listar los roles
   */
  getAllRoleMaster(): void {
    this.roleService.getAllRoleMaster().subscribe({
      next: response => {
        this.listRole = response;
      }, error: error => {
        this.loadListing = false;
        console.log(error);
      }
    });
  }

  formRoleComponent = new FormGroup({
    functionCode: new FormControl(''),
    meaning: new FormControl(''),
    active: new FormControl(false),
  });


  /**
   * Función encargada de crear o actualizar un rol maestro dentro de la aplicación.
   */
  createOrUpdateRole(): void {
    this.formRoleComponent.markAllAsTouched()
    const role: Role = this.formRoleComponent.getRawValue();
    if (this.creatingRole) {
      role.functionCode = 'ROLE_' + role.functionCode;
      this.roleService.createRoleMaster(role).subscribe({
        next: () => {
          this.messageVisibility.isErrorFirts = false;
          this.messageVisibility.isSuccessFirst = true;
          this.errorMessage = "S'ha creat correctament"
          this.resetValues();
          this.creatingRole = false;
        }, error: error => {
          this.messageVisibility.isErrorFirts = true;
          this.messageVisibility.isSuccessFirst = false;
          this.errorMessage = error.error.message
          console.log(error);
        }
      });
    } else {
      this.roleService.updateRoleMaster(role).subscribe({
        next: () => {
          this.messageVisibility.isErrorFirts = false;
          this.messageVisibility.isSuccessFirst = true;
          this.errorMessage = "S'ha editat correctament"
        }, error: error => {
          this.messageVisibility.isErrorFirts = true;
          this.messageVisibility.isSuccessFirst = false;
          this.errorMessage = error.error.message
          console.log(error);
        }
      });
    }
  }

  checkRow(role?: Role): void {
    if (role) {
      if (this.selectedRowId === role.functionCode) {
        this.selectedRowId = '';
        return;
      }
      // Modo edición
      this.selectedRowId = String(role.functionCode);
      this.updateRole = true;
      this.creatingRole = false;
      this.formRoleComponent.patchValue({
        functionCode: role.functionCode,
        meaning: role.meaning,
        active: role.active,
      });

    } else {
      // Modo creación
      this.selectedRowId = '';
      this.updateRole = false;
      this.creatingRole = true;
      this.formRoleComponent.reset();
      this.formRoleComponent.patchValue({
        active: true
      });
    }
    window.scrollTo(0, 600);
    this.changeDetector.detectChanges();
  }

  /**
   * Función encargada de elminar el rol master dentro de la aplicación
   */
  deleteRole() {
    this.roleService.deleteRoleMaster(this.selectedRowId).subscribe({
      next: () => {
        this.resetValues();
      }, error: error => {
        console.log(error);
      }
    });
  }

  private resetValues(): void {
    this.getAllRoleMaster();
    this.formRoleComponent.reset();
    this.selectedRowId = '';
  }

  /**
   * Se encargada de devolver a la salida la acotación del rol
   * @param role 
   * @returns 
   */
  generateCodi(role: any): string {
    return role.includes('ADMIN') ? 'Admin' :
      role.includes('GESTOR') ? 'GE'
        : 'ES';
  }


}
